<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col class="pa-0">
            <v-tabs
                app
                show-arrows
                :height="32"
				class="tabs-route"
                background-color="transparent"
                slider-color="primary">
                <v-tab exact-path ripple :to="{ path: '/agents/' + id + '/'}" key="agents" >Agente</v-tab>
                <v-tab exact-path ripple :to="{ path: '/agents/' + id + '/analytics' }" key="analytics">Statistiche</v-tab>
            </v-tabs>

            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath" :entity-title="entityTitle"></router-view>
            </v-slide-y-reverse-transition>
        </v-col>
    </v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'agent-tabs',
        props: {
            id: Number,
        },

        data() {
            return {
                model: {},
            }
        },

        computed: {
            entityTitle()  {
                return this.model ? ['name'].reduce((acc, key) => this.model[key] ? acc.concat(this.model[key]) : acc, []).join(' / ') : ''
            }
        },        

        created() {
            this.$store.commit('endProgress')
            this.axios.get('agents/' + this.id + '?&lite=1').then(response => {
                this.model = response.data.model

            }, response => {
                // error callback
            })
        },
    }
</script>
